import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8765242a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "advertisTrade1" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["infinite-scroll-disabled"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "flexBothEnds" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" USDT ")
const _hoisted_7 = { class: "fontBright" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "flexBothEnds marT10" }
const _hoisted_11 = { class: "avatar" }
const _hoisted_12 = { class: "name" }
const _hoisted_13 = { class: "fontSize13" }
const _hoisted_14 = {
  key: 0,
  class: "loadEnd"
}
const _hoisted_15 = {
  key: 1,
  class: "loadEnd"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_arrow_right = _resolveComponent("arrow-right")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_OrderDetails = _resolveComponent("OrderDetails")!
  const _component_OrderChat = _resolveComponent("OrderChat")!
  const _directive_infinite_scroll = _resolveDirective("infinite-scroll")!

  return (_openBlock(), _createBlock(_component_el_row, {
    class: "advertisTrade marT10",
    gutter: 20
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_col, { span: 8 }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_row, { class: "tabs" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabsArr, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_col, {
                    span: 8,
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        onClick: ($event: any) => (_ctx.onTab(index)),
                        class: _normalizeClass(['item', { active: _ctx.tabI == index }])
                      }, _toDisplayString(item), 11, _hoisted_2)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }),
            _withDirectives(_createElementVNode("div", {
              class: "advertsItems scroll",
              "infinite-scroll-disabled": _ctx.isLoadEnd
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payArr, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: _normalizeClass(['itemBox', { active: _ctx.itemBoxI == index }]),
                  onClick: ($event: any) => (_ctx.onItemBox(item, index))
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass({ fontBright: _ctx.isMySell(item.payUserId) })
                      }, _toDisplayString(_ctx.isMySell(item.payUserId) ? _ctx.langObj.l0018 : _ctx.langObj.l0017), 3),
                      _hoisted_6
                    ]),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.Config.currency.symbol + item.totalCny.toFixed(2)), 1)
                  ]),
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.langObj.l0033), 1),
                          _createElementVNode("div", null, _toDisplayString(item.amount.toFixed(6)), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.langObj.l0041), 1),
                          _createElementVNode("div", null, _toDisplayString(_ctx.formatDateTime(item.createTime)), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.showName(item).substring(0, 1)), 1),
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.showName(item)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("span", {
                        class: _normalizeClass(_ctx.getClassName(item))
                      }, _toDisplayString(_ctx.getStatus(item.status)), 3),
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_arrow_right)
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ], 10, _hoisted_4))
              }), 128)),
              (_ctx.isLoadStart)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.langObj.l0053), 1))
                : (!_ctx.isLoadStart && _ctx.isLoadEnd)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.langObj.l0054), 1))
                  : _createCommentVNode("", true)
            ], 8, _hoisted_3), [
              [_directive_infinite_scroll, _ctx.onOrderRecord]
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_col, { span: 8 }, {
        default: _withCtx(() => [
          _createVNode(_component_OrderDetails, { ref: "orderDetails" }, null, 512)
        ]),
        _: 1
      }),
      _createVNode(_component_el_col, { span: 8 }, {
        default: _withCtx(() => [
          _createVNode(_component_OrderChat, { ref: "orderChat" }, null, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}